"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rugbyLeagueConfig = {
    clock: {
        direction: 'up',
        endPeriodType: 'stopAtLength',
        cumulative: true
    }
};
//# sourceMappingURL=sportConfig.js.map